import React from 'react';
export function SolutionSection() {
  return <section className="py-16 md:py-24 bg-gradient-to-b from-zinc-950 to-zinc-900 relative overflow-hidden" data-id="element-231">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-600/10 blur-[150px] rounded-full pointer-events-none" data-id="element-232"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-233">
        <div className="max-w-4xl mx-auto text-center" data-id="element-234">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6 md:mb-8" data-id="element-235">
            El asado no es magia. Es un sistema.
          </h2>

          <p className="text-base md:text-xl text-zinc-300 mb-8 md:mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-236">
            Acá no te vamos a vender talento ni feeling ni "el don del asador".
            El asado perfecto existe porque tomás decisiones correctas en el
            orden correcto.
          </p>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-12 md:mb-16" data-id="element-237">
            {['Qué corte comprás y cómo lo elegís.', 'A qué altura va cada cosa y a qué temperatura.', 'Cuándo salás, con qué y por qué importa el momento.', 'En qué orden entra todo para que llegue junto a la mesa.', 'Qué hacés cuando algo se complica.'].map((text, i) => <span key={i} className="bg-zinc-800/50 border border-zinc-700 px-3 md:px-4 py-2 rounded-full text-zinc-300 text-xs md:text-base" data-id="element-238">
                {text}
              </span>)}
          </div>

          <p className="text-base md:text-lg text-zinc-400 leading-relaxed mb-6 md:mb-8" data-id="element-239">
            Eso es todo. No es arte. No es intuición. Es un sistema.
          </p>

          <p className="text-base md:text-lg text-zinc-400 leading-relaxed mb-12 md:mb-16" data-id="element-240">
            Y ese sistema lo usaban los asadores de campo hace dos siglos sin
            termómetro, sin cronómetro y sin ninguna app. Nosotros lo escribimos
            para que vos lo uses el próximo sábado.
          </p>

          <div className="border-t border-zinc-800 pt-12 md:pt-16" data-id="element-241">
            <p className="text-amber-500 font-bold tracking-widest uppercase mb-4" data-id="element-242">
              EL SISTEMA
            </p>
            <h3 className="text-2xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-243">
              CÓDIGO ASADO: EL SISTEMA MAESTRO CENTENARIO™
            </h3>
            <p className="text-lg md:text-xl text-zinc-300 font-serif italic" data-id="element-244">
              11 Tomos. Todo lo que necesitás para dominar el asado argentino de
              una vez por todas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}